<template>
  <b-modal
    v-model="show"
    scrollable
    :title="'Alterar preço de ' + items.length + ' ' + $gui.batchesLC"
    ok-title="Confirmar"
    cancel-title="Cancelar"
    :ok-disabled="sending || items.length === 0"
    @ok.prevent="submit"
  >
    <b-alert :show="error !== ''" variant="danger">
      {{ error }}
      <b-link class="ml-2" @click="$emit('reload')">Recarregar</b-link>
    </b-alert>

    <p class="mb-1 font-weight-bold">Serão alterados:</p>
    <div class="border rounded p-2 mb-3" style="max-height: 180px; overflow-y: auto;">
      <div v-for="item in items" :key="item.id" class="d-flex justify-content-between">
        <span>{{ item.name }}</span>
        <span class="text-muted ml-3">{{ item.value > 0 ? $options.filters.currency(item.value) : 'Grátis' }}</span>
      </div>
    </div>

    <b-form-group>
      <p class="mb-2 font-weight-bold">Novo preço</p>
      <b-input-group prepend="R$">
        <money class="form-control" v-model="value" v-bind="money"></money>
      </b-input-group>
    </b-form-group>
  </b-modal>
</template>

<script>
import {Money} from 'v-money'

export default {
  name: 'BatchPriceModal',
  components: { Money },
  props: {
    visible: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
    organizer: { type: String, default: '' }
  },
  data () {
    return {
      value: 0,
      sending: false,
      error: '',
      money: { decimal: ',', thousands: '.', prefix: '', suffix: '', precision: 2 }
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  watch: {
    visible (open) {
      if (open) {
        this.value = 0
        this.error = ''
        this.sending = false
      }
    }
  },
  methods: {
    submit () {
      this.sending = true
      this.error = ''
      const url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/batch-prices'
      const body = {
        batch_ids: this.items.map(item => item.id),
        value: Math.round(this.value * 100),
        user_agent: navigator.userAgent
      }
      this.$http.put(url, body).then(res => {
        this.sending = false
        this.$emit('updated', res.body)
        this.$emit('close')
      }, err => {
        this.sending = false
        this.error = (err.body && err.body.message) || 'Não foi possível alterar o preço.'
      })
    }
  }
}
</script>
